import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const TextFieldGroup = ({
  name,
  placeholder,
  value,
  label,
  labelClass,
  error,
  info,
  grid,
  type,
  onChange,
  disabled
}) => {
  return (
    <div className="row">
      <div className="input-field col s12">
        <input
          className={classnames({'invalid': error})}
          name={name}
          placeholder={placeholder}
          type={type}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
        <label htmlFor={name} className={labelClass}>{label}</label>
        {error && (<span className="helper-text" data-error={error}>)>{error}</span>)}
      </div>
    </div>
  );
};

TextFieldGroup.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  labelClass: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  info: PropTypes.string,
  grid: PropTypes.string,
  error: PropTypes.string,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.string
}

TextFieldGroup.defaultProps = {
  type: 'text',
  grid: 's12'
}

export default TextFieldGroup;



// WEBPACK FOOTER //
// ./src/components/common/TextFieldGroup.js